import Service from './service'
export var ApiCustomMessageType;
(function (ApiCustomMessageType) {
  ApiCustomMessageType["CUSTOM_EVENT_CORE"] = "system.custom.event.core"
  ApiCustomMessageType["CUSTOM_EVENT_JS"] = "system.custom.event.js"
})(ApiCustomMessageType || (ApiCustomMessageType = {}))
export var CustomMessageType;
(function (CustomMessageType) {
  CustomMessageType["RESTART"] = "RESTART"
  CustomMessageType["CUSTOM"] = "CUSTOM"
  CustomMessageType["CASE_START"] = "CASE_START"
  CustomMessageType["CASE_STOP"] = "CASE_STOP"
})(CustomMessageType || (CustomMessageType = {}))
/**
 * Сервис для сообщений пользовательского типа
 * @version 0.0.1
 * @since 1.9.0
 */
export default class CustomService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiCustomMessageType.CUSTOM_EVENT_CORE:
          if (typeof message.custom !== 'undefined') {
            this.broadcast(CustomMessageType.CUSTOM, message)
          }
          else if (message.restart === true) {
            this.broadcast(CustomMessageType.RESTART)
          }
          else if (message.startCase === true) {
            this.broadcast(CustomMessageType.CASE_START)
          }
          else if (message.stopCase === true) {
            this.broadcast(CustomMessageType.CASE_STOP)
          }
          break
      }
    }
    this.messageChannel.subscribe(ApiCustomMessageType.CUSTOM_EVENT_CORE, messageHandler)
  }
  /**
     * Не используется
     * @since 1.9.0
     * @param {function} callback - функция
     * @deprecated
     */
  onCaseStart(callback) {
    return this.subscribe(CustomMessageType.CASE_START, callback)
  }
  /**
     * Не используется
     * @since 1.9.0
     * @param {function} callback - функция
     * @deprecated
     */
  onCaseStop(callback) {
    return this.subscribe(CustomMessageType.CASE_STOP, callback)
  }
  /**
     * Не используется
     * @since 1.9.0
     * @param {function} callback - функция
     * @deprecated
     */
  onRestart(callback) {
    return this.subscribe(CustomMessageType.RESTART, callback)
  }
  /**
     * Пришло сообщение пользовательского типа
     * @since 1.9.0
     *
     * @param {(data: any) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof CustomService
     *
     * @example <caption>Пришло сообщение пользовательского типа</caption>
     * robot.customService.onCustom((data) => {
     *   ...
     * })
     */
  onCustom(callback) {
    return this.subscribe(CustomMessageType.CUSTOM, callback)
  }
  /**
     * Отправить сообщение пользовательского типа
     * @since 1.9.0
     *
     * @param {*} message
     * @memberof CustomService
     *
     * @example <caption>Отправить сообщение пользовательского типа</caption>
     * robot.customService.sendCustom(message)
     */
  sendCustom(message) {
    this.messageChannel.send(Object.assign(message, {
      type: ApiCustomMessageType.CUSTOM_EVENT_JS,
    }))
  }
}
